import React, { useState, useEffect } from 'react';
import {  AppBar, Toolbar, Box ,Grid, TextField, Button, Typography, MenuItem, Select, FormControl, InputLabel, Rating,  Chip, OutlinedInput, FormControlLabel ,Checkbox , Divider, Radio, RadioGroup, FormLabel } from '@mui/material';
import axiosInstance from '../common/axios';
import LeftDrawer from '../components/LeftDrawer';
import { useAuth } from '../context/AuthContext';
import { useLocation, useNavigate  } from 'react-router-dom'; 
import {countryCodes} from '../common/countries';

const TraderForm = () => { 
    
          const navigate = useNavigate(); 
      const { user } = useAuth();
        const { email, name, userId, roles, userTypes} =  user || {};
    
      const [categoryIds, setCategory] = useState([]);
    
  const [formData, setFormData] = useState({
    traderName: '',
    traderEmail: '',
    traderCountryCode: '',
    traderPhone: '',
    employeeCount: '',
    country: '', 
    annualTurnover: '',
    categoryIds: [],
            taxIdentificationNumber:'',
      businessLicenseNumber:'',
       officeAddress: { streetAddressLine1: '', streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
    billingAddress: { streetAddressLine1: '',  streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
    shippingAddress: { streetAddressLine1: '',  streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
          estYear: '',
	website: '',
	hasExportLicense: 0, 
      traderCertificationDTO:[],
  });
    
      const [certifications, setCertifications] = useState([]);
    
    
      // Fetch company types and user types from the API when component mounts
  useEffect(() => {

    const fetchTypes = async () => {
      try {
        const categoryResponse = await axiosInstance.get(`/api/traders/categories`);
          console.log("companyResponse: "+ categoryResponse );
          setCategory(categoryResponse.data);
        
      } catch (error) {
        console.error('Error fetching types:', error);
      }
    };
      
        const fetchCertifications = async () => {
      try {
        const certificationResponse = await axiosInstance.get(`/api/certifications`);
          console.log("certificationResponse: "+ certificationResponse );
          setCertifications(certificationResponse.data);
        
      } catch (error) {
        console.error('Error fetching types:', error);
      }
    };
      
      fetchCertifications();
    fetchTypes();
    }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };
    
        const handleCategoryChange = (event) => {
  const selectedIds = event.target.value;
  setFormData({ ...formData, categoryIds: selectedIds });
};


  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await axiosInstance.post('/api/traders', formData);
      console.log('Trader data submitted successfully:', response.data);
        
        alert("Trader data submitted successfully");
    setFormData({
    traderName: '',
    traderEmail: '',
    traderCountryCode: '',
    traderPhone: '',
    employeeCount: '',
    country: '', 
    annualTurnover: '', 
    categoryIds: [],
            taxIdentificationNumber:'',
      businessLicenseNumber:'',
       officeAddress: { streetAddressLine1: '', streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
    billingAddress: { streetAddressLine1: '',  streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
    shippingAddress: { streetAddressLine1: '',  streetAddressLine2: '', city: '', state: '', zipCode: '', country: '' },
      traderCertificationDTO:[],
            estYear: '',
	website: '',
	hasExportLicense: 0, 
  });
        
    } catch (error) {
      console.error('Error submitting trader data:', error);
           alert("Error submitting trader data. Please contact adminstrator makes user the email id is unique!!");
    }
  };
    
    
        const handleRadioChange = (e) => {
        const { name, value } = e.target;
        console.log(name);
        console.log(value);
        
        setFormData((prevFormData) => ({ ...prevFormData, [name]: value, })); 
    };
    
    
    // Handle checkbox selection for certifications
  const handleCheckboxChange = (certificationId) => {
      console.log("in the handle checkbox change");
    const isSelected = formData.traderCertificationDTO.some(
      (cert) => cert.certificationId === certificationId
    );

      
    if (isSelected) {
      setFormData((prev) => ({
        ...prev,
        traderCertificationDTO: prev.traderCertificationDTO.filter(
          (cert) => cert.certificationId !== certificationId
        ),
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        traderCertificationDTO: [
          ...prev.traderCertificationDTO,
          { certificationId, issueDate: "", expiryDate: "" },
        ],
      }));
    }
  };

  // Handle date changes (issueDate or expirationDate)
  const handleDateChange = (certificationId, field, value) => {
    setFormData((prev) => ({
      ...prev,
      traderCertificationDTO: prev.traderCertificationDTO.map((cert) =>
        cert.certificationId === certificationId
          ? { ...cert, [field]: value }
          : cert
      ),
    }));
  };
    
    
    
    
    
    
             const [sameAsBilling, setSameAsBilling] = useState(false);
      const [sameAsOffice, setSameAsOffice] = useState(false);
  const handleAddressChange = (type, field, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [type]: { ...prevState[type], [field]: value },
    }));

    if (type === 'officeAddress' && sameAsOffice) {
      setFormData((prevState) => ({
        ...prevState,
        billingAddress: { ...prevState.officeAddress, [field]: value },
      }));
    }
    if (type === 'billingAddress' && sameAsBilling) {
      setFormData((prevState) => ({
        ...prevState,
        shippingAddress: { ...prevState.billingAddress, [field]: value },
      }));
    }
  };
    
  const handleSameAsOffice = (event) => {
    const isChecked = event.target.checked;
    setSameAsOffice(isChecked);
    if (isChecked) {
      setFormData((prevState) => ({
        ...prevState,
        billingAddress: { ...prevState.officeAddress },
      }));
    }
  };

  const handleSameAsBilling = (event) => {
    const isChecked = event.target.checked;
    setSameAsBilling(isChecked);
    if (isChecked) {
      setFormData((prevState) => ({
        ...prevState,
        shippingAddress: { ...prevState.billingAddress },
      }));
    }
  };

    
  const renderAddressFields = (label, type) => (
    <>
      <Typography variant="h6" gutterBottom>{label}</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Street Address"
            fullWidth
            required
            value={formData[type].streetAddressLine1}
            onChange={(e) => handleAddressChange(type, 'streetAddressLine1', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Street Address"
            fullWidth
            required
            value={formData[type].streetAddressLine2}
            onChange={(e) => handleAddressChange(type, 'streetAddressLine2', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="City"
            fullWidth
            required
            value={formData[type].city}
            onChange={(e) => handleAddressChange(type, 'city', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="State"
            fullWidth
            required
            value={formData[type].state}
            onChange={(e) => handleAddressChange(type, 'state', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Zip Code"
            fullWidth
            required
            value={formData[type].zipCode}
            onChange={(e) => handleAddressChange(type, 'zipCode', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            label="Country"
            fullWidth
            required
            value={formData[type].country}
            onChange={(e) => handleAddressChange(type, 'country', e.target.value)}
          />
        </Grid>
      </Grid>
    </>
  );


  // Navigation handlers for the menu items
  const handleRequestQuote = () => navigate('/request-quote');
  const handleQuoteList = () => navigate('/quote-list');
  const handleOrders = () => navigate('/orders');
     const handleTracker = () => navigate('/tracker');
    
      const handleDealer = () => navigate('/dealerreg');
      const handleDealers = () => navigate('/dealers');
     
  const handleSupplier = () => navigate('/suppliereg');
      const handleSuppliers = () => navigate('/suppliers');
     const handleManufacturer = () => navigate('/manufacturerreg');
    
     const handleManufacturers = () => navigate('/manufacturers');
    
      const handleDashboard = () => navigate('/dashboard');
    
   const handleProfile = () => navigate('/profile');
    const handlePurchaseOrder = () => navigate('/purchaseorder')
    const handleSendEstimate = () => navigate('/send-estimate')
    const handleEstimate = () => navigate('/estimate')
   const handlePartner = () => navigate('/partner')
      const handleInvoice = () => navigate('/invoice')
      const handleTrader = () => navigate('/trader')
        const handleBuilder = () => navigate('/builder')
       const handlePartnerView = () => navigate('/partnerview')
      const handlePurchaseOrderList = () => navigate('/purchaseorderlist')
      const handleInvoiceView = () => navigate('/invoiceview')
         const handleReport = () => navigate('/report');
       const handleParts = () => navigate('/parts');
           const handlePartGroup = () => navigate('/partgroup');
         const handleBuilders = () => navigate('/builders');
         const handleTraders = () => navigate('/traders');
        const handleGRN = () => navigate('/grn');
    
    
    
  return (

    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      {/* Header at the Top */}
       <AppBar position="static" sx={{ backgroundColor: '#941B0C' }}>
      <Toolbar>
        {/* Left-aligned Dashboard Title */}
        <Typography variant="h6" noWrap component="div">
          Dashboard
        </Typography>

        {/* Spacer to push the name to the right */}
        <Box sx={{ flexGrow: 1 }} />

        {/* Right-aligned Name */}
        <Typography variant="h6" noWrap component="div">
          Welcome {name}
        </Typography>
      </Toolbar>
    </AppBar>

     <Box sx={{ display: 'flex', flexGrow: 1 }}>
        <LeftDrawer
        handleDashboard={handleDashboard}
      handleProfile={handleProfile}
          handleRequestQuote={handleRequestQuote}
          handleQuoteList={handleQuoteList}
          handleOrders={handleOrders}
          handleTracker={handleTracker}
          handleDealer={handleDealer}
          handleDealers={handleDealers}
          handleSupplier={handleSupplier}
       handleSuppliers={handleSuppliers}
          handleManufacturer={handleManufacturer}
      handleManufacturers={handleManufacturers}
        handlePurchaseOrder={handlePurchaseOrder}
      handleSendEstimate={handleSendEstimate}
      handleEstimate={handleEstimate}
       handlePartner={handlePartner}
      handleInvoice={handleInvoice}
      handleTrader={handleTrader}
      handleBuilder={handleBuilder}
      handlePartnerView={handlePartnerView}
      handlePurchaseOrderList={handlePurchaseOrderList}
      handleInvoiceView={handleInvoiceView}
      handleReport={handleReport}
      handleParts={handleParts}
      handlePartGroup={handlePartGroup}
      handleTraders={handleTraders}
      handleBuilders={handleBuilders}
            handleGRN={handleGRN}
          userRoles={roles}
          userTypes={userTypes}
/>
      
          <Box sx={{ maxWidth: 600, margin: '0 auto', padding: 3 }}>
    <form onSubmit={handleSubmit}>
      <Grid container spacing={3} >
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            Trader Information Form
          </Typography>
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Trader Name"
            name="traderName"
            value={formData.traderName}
            onChange={handleChange}
            required
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Email"
            name="traderEmail"
            value={formData.traderEmail}
            onChange={handleChange}
            type="email"
            required
          />
        </Grid>
        <Grid item xs={12} sm={3}>
             {/* Country */}
        <FormControl fullWidth sx={{ marginBottom: 2 }}>
          <InputLabel>Country</InputLabel>
          <Select
            name="traderCountryCode"
            value={formData.traderCountryCode}
            onChange={handleChange}
            required
          >
            {countryCodes.map((country) => (
              <MenuItem key={country.code} value={country.country}>
                {country.country}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        </Grid>
        <Grid item xs={12} sm={3}>
          <TextField
            fullWidth
            label="Phone Number"
            name="traderPhone"
            value={formData.traderPhone}
            onChange={handleChange}
            type="tel"
          />
        </Grid>
              <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Country"
            name="country"
            value={formData.country}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Employee Count"
            name="employeeCount"
            value={formData.employeeCount}
            onChange={handleChange}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Annual Turnover"
            name="annualTurnover"
            value={formData.annualTurnover}
            onChange={handleChange}
          />
        </Grid>

        {/* State */}
        <TextField
          fullWidth 
          label="Established Year"
          variant="outlined"
          name="estYear"
          value={formData.estYear}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />


        {/* State */}
        <TextField
          fullWidth 
          label="Website"
          variant="outlined"
          name="website"
          value={formData.website}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />



  <Divider style={{ margin: '20px 0' }} />


        {/* Other form fields */}
        <Grid item xs={12} sm={6}>
          <FormControl fullWidth>
            <InputLabel>Category</InputLabel>
            <Select
              name="categoryIds"
              value={formData.categoryIds}
              onChange={handleCategoryChange}
              multiple
              input={<OutlinedInput label="Category" />}
              renderValue={(selected) => (
         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
        {/* Map over selected IDs and display their names */}
        {selected.map((categoryId) => {
          const selectedType = categoryIds.find((type) => type.categoryId === categoryId);
          return <Chip key={categoryId} label={selectedType?.categoryName} />;
        })}
      </Box>
              )}
            >

  <MenuItem value="">
      <em>Select Category</em>
    </MenuItem>
    {categoryIds.map((type) => (
      <MenuItem key={type.categoryId} value={type.categoryId}>
        {type.categoryName}
      </MenuItem>
    ))}
            </Select>
          </FormControl>
        </Grid>

 <Grid item xs={12}>
     </Grid>



   <FormControl component="fieldset">
    <FormLabel component="legend">Export License</FormLabel>
     <RadioGroup aria-label="hasExportLicense" name="hasExportLicense" value={formData.hasExportLicense} onChange={handleRadioChange} > 
         <FormControlLabel value="1" control={<Radio />} label="Yes" />
          <FormControlLabel value="0" control={<Radio />} label="No" /> 
    </RadioGroup>
  </FormControl>


         {/* State */}
        <TextField
          fullWidth 
          label="Business License Number"
          variant="outlined"
          name="businessLicenseNumber"
          value={formData.businessLicenseNumber}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />

        {/*  */}
        <TextField
          fullWidth
          label="Tax Identification Number"
          variant="outlined"
          name="taxIdentificationNumber"
          value={formData.taxIdentificationNumber}
          onChange={handleChange}
          sx={{ marginBottom: 2 }}
        />
      
  {/* Certifications Section */}
        <Typography variant="h6" gutterBottom>Select Certifications</Typography>

      <Grid item xs={12} sm={6}>
        {certifications.map((certification) => (
          <div key={certification.id}>
            <label>
              <input
                type="checkbox"
                onChange={() => handleCheckboxChange(certification.id)}
              />
              {certification.name}
            </label>
            {formData.traderCertificationDTO.some(
              (cert) => cert.certificationId === certification.id
            ) && (
              <div style={{ marginLeft: "20px" }}>
                <label>
                  Issue Date:{" "}
                  <input
                    type="date"
                    onChange={(e) =>
                      handleDateChange(
                        certification.id,
                        "issueDate",
                        e.target.value
                      )
                    }
                  />
                </label>
                <br />
                <label>
                  Expiration Date:{" "}
                  <input
                    type="date"
                    onChange={(e) =>
                      handleDateChange(
                        certification.id,
                        "expiryDate",
                        e.target.value
                      )
                    }
                  />
                </label>
              </div>
            )}
          </div>
        ))}
     </Grid>



     {renderAddressFields("Office Address", "officeAddress")}

      <FormControlLabel
        control={
          <Checkbox
            checked={sameAsOffice}
            onChange={handleSameAsOffice}
            color="primary"
          />
        }
        label="Billing address is the same as office address"
      />

      {!sameAsOffice && renderAddressFields("Billing Address", "billingAddress")}

      
      <FormControlLabel
        control={
          <Checkbox
            checked={sameAsBilling}
            onChange={handleSameAsBilling}
            color="primary"
          />
        }
        label="Shipping address is the same as billing address"
      />

      {!sameAsBilling && renderAddressFields("Shipping Address", "shippingAddress")}
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary">
            Submit
          </Button>
        </Grid>
      </Grid>
    </form>
</Box> 
</Box>
</Box>
  );
};

export default TraderForm;
